// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallJoinContent__wrapper___-8x-v","control":"CallJoinContent__control___2cpp-"};